<template>
  <v-dialog
    v-model="localShow"
    persistent
    v-if="attachment !== null"
    max-width="65%"
    @click:outside="close"
    @keydown.esc="close"
    style="background-color: rgb(var(--v-theme-surface));"
    content-class="attachment"
  >
    <div>
      <div class="text-h6 pt-4 text-center">{{ attachment.fileName }}</div>
      <PdfViewer :documentUrl="documentUrl" :downloadUrl="downloadUrl" :isReadonly="true" :zoomDisabled="true">
        <template v-slot:actions>
          <v-btn size="large" @click="close()" variant="text" class="mr-2">
            <v-icon start>mdi-close</v-icon>
            Close
          </v-btn>
        </template>
      </PdfViewer>
    </div>
  </v-dialog>
</template>

<script>
import { API_URL } from "../env";
import PdfViewer from "@/components/PdfViewer.vue";

export default {
  name: "AttachmentDialog",
  components: { PdfViewer },
  props: {
    attachment: Object,
    show: Boolean,
    close: Function,
  },
  emits: ["update:show"],
  data() {
    return {
      localShow: this.show,
    };
  },
  watch: {
    show(val) {
      this.localShow = val;
    },
    localShow(val) {
      if (!val) this.$emit("update:show", val);
    },
  },
  init() {},
  computed: {
    documentUrl() {
      return `${API_URL}/download/attachment/${this.attachment.id}/pdf`;
    },
    downloadUrl() {
      return `${API_URL}/download/attachment/${this.attachment.id}`;
    },
  },
  methods: {},
};
</script>
<style>
.attachment {
  background-color: rgb(var(--v-theme-surface));
  width: 100%;
  overflow-y: scroll;
}
</style>
